/** 报表标题后的数据说明入口；复用 chip 与 Dialog，统一展示口径、公式和假设示例。 */
import { useState } from 'react';
import { Dialog, DialogBody } from '~/ui/Dialog';
import {
  METRICS_DATA_EXPLANATIONS,
  type MetricsDataExplanationId,
} from './metrics-data-explanations';

export function MetricsDataExplanation({ report }: { report: MetricsDataExplanationId }) {
  const [open, setOpen] = useState(false);
  const explanation = METRICS_DATA_EXPLANATIONS[report];
  return (
    <>
      <button
        type="button"
        className="chip"
        aria-label={`数据说明：${explanation.title}`}
        aria-haspopup="dialog"
        aria-expanded={open}
        onClick={() => setOpen(true)}
        style={{ cursor: 'pointer', fontWeight: 400 }}
      >
        数据说明 <span aria-hidden="true">?</span>
      </button>
      {open && (
        <Dialog
          title={`${explanation.title} · 数据说明`}
          subtitle={explanation.summary}
          icon="IconInfo"
          width={720}
          onClose={() => setOpen(false)}
          footer={
            <button type="button" className="btn" onClick={() => setOpen(false)}>
              知道了
            </button>
          }
        >
          <DialogBody gap={18}>
            {explanation.sections.map((section) => (
              <section key={section.title} className="vstack" style={{ gap: 8 }}>
                <h3 style={{ margin: 0, fontSize: 13, fontWeight: 600 }}>{section.title}</h3>
                {section.details.map((detail) => (
                  <p key={detail} style={{ margin: 0, fontSize: 12.5, lineHeight: 1.7 }}>
                    {detail}
                  </p>
                ))}
                {section.formulas && (
                  <div className="card-flat" style={{ padding: 12 }}>
                    {section.formulas.map((formula) => (
                      <p
                        key={formula}
                        className="mono"
                        style={{ margin: 0, fontSize: 12, lineHeight: 1.8 }}
                      >
                        {formula}
                      </p>
                    ))}
                  </div>
                )}
                {section.example && (
                  <div
                    className="card-flat"
                    style={{ padding: 12, fontSize: 12.5, lineHeight: 1.7 }}
                  >
                    <b>示例（假设）</b>
                    <p style={{ margin: '4px 0 0' }}>{section.example}</p>
                  </div>
                )}
              </section>
            ))}
            <p style={{ margin: 0, fontSize: 11.5, color: 'var(--fg-muted)' }}>
              示例数字仅用于说明算法，不代表当前筛选下的真实数据。
            </p>
          </DialogBody>
        </Dialog>
      )}
    </>
  );
}

export function MetricsDataTableHeading({
  title,
  report,
}: { title: string; report: MetricsDataExplanationId }) {
  return (
    <div
      className="hstack"
      style={{
        gap: 8,
        flexWrap: 'wrap',
        padding: '12px 14px',
        borderBottom: '1px solid var(--border)',
      }}
    >
      <h2 style={{ margin: 0, fontWeight: 600, fontSize: 13 }}>{title}</h2>
      <MetricsDataExplanation report={report} />
    </div>
  );
}
